import { useTranslations } from 'next-intl';
import { useProduct } from '../ProductCard';

export const ProductOutOfStock: React.FC = () => {
  const tCatalog = useTranslations('Catalog');
  const product = useProduct();

  if (!product || product.inventory_available) {
    return null;
  }

  return (
    <>
      <div className="tw-pointer-events-none tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-top-0 tw-hidden tw-h-full tw-bg-white tw-opacity-50 group-[.out-of-stock]:tw-block" />
      <div
        data-testid="product-out-of-stock-message"
        className={`
        tw-absolute tw-left-0 tw-right-0 tw-top-[65px] tw-hidden tw-w-full tw-justify-center
        group-[.out-of-stock]:tw-flex desktop:tw-top-[77px]
        `}
      >
        <p className="tw-lf-subtitle-sm tw-bg-white tw-text-center">
          {tCatalog('endOfStock')}
        </p>
      </div>
    </>
  );
};
